export default [
  { key: "ESP32LoRa", text: "ESP 32 LoRa", value: "ESP32LoRa" },
    { key: "RasPi0", text: "Raspberri Pi 0", value: "RPi0" },
    { key: "RasPi3Bplus", text: "Raspberri Pi 3 B+", value: "RPi3Bplus" },
     { key: "NodeMcu", text: "NodeMcu", value: "NodeMcu" }
];
